// extracted by mini-css-extract-plugin
export default {"users":"style_users__wQHJe","edit":"style_edit__p1Mxi"};